import type { Api } from '@pflegenavi/shared-frontend/platform';
import { get, getApiBaseUrl } from '@pflegenavi/shared-frontend/platform';
import type { ServiceProviderPaymentsControllerResultTypes } from '@pflegenavi/service-provider-shared/api-endpoints';
import { ServiceProviderPaymentsControllerDefinition } from '@pflegenavi/service-provider-shared/api-endpoints';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';

export interface IServiceProviderPaymentsApi extends Api {
  getReceiptBatchPaymentStatus(dataIn: {
    params: {
      receiptBatchId: string;
    };
  }): Promise<
    ServiceProviderPaymentsControllerResultTypes['getReceiptBatchPaymentStatus']
  >;
}

export class ServiceProviderPaymentsApi implements IServiceProviderPaymentsApi {
  baseUrl: string;

  getReceiptBatchPaymentStatus: IServiceProviderPaymentsApi['getReceiptBatchPaymentStatus'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.baseUrl = getApiBaseUrl(tenantId, apiUrl);

    this.getReceiptBatchPaymentStatus = get({
      authContext,
      url: (params) => {
        return `${this.baseUrl}/${ServiceProviderPaymentsControllerDefinition.controller}/${ServiceProviderPaymentsControllerDefinition.endpoints.getReceiptBatchPaymentStatus.url}`.replace(
          ':receiptBatchId',
          params.receiptBatchId
        );
      },
    });
  }
}
